import * as MuiInputLabel from '@mui/material/InputLabel'
import React from 'react'

export type InputLabelProps = MuiInputLabel.InputLabelProps

export function InputLabel({ children, ...props }: InputLabelProps) {
  return <MuiInputLabel.default {...props}>{children}</MuiInputLabel.default>
}
